import React, { useMemo } from 'react';

import useChartData from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useChartData';
import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import Snackbar from 'components/DesignSystem/Snackbar';
import EChartsReact from 'components/ThemedECharts';
import CentralizedSpinner from 'components/CentralizedSpinner';
import HeatmapTable from 'components/Meteorology/TrackingForecast/DetailedView/HeatmapTable';
import heatmapMatrixFromOption from 'helper/Meteorology/TrackingForecast/DetailedView/heatmapMatrixFromOption';
import withScrollableLegend from 'helper/Meteorology/TrackingForecast/DetailedView/scrollableLegend';

import './index.scss';

export default function TFDVChart() {
  const {
    key,
    data,
    queryError,
    isFetching,
    autoQuerying,
  } = useChartData();

  const matrix = useMemo(() => heatmapMatrixFromOption(data), [data]);

  // `autoQuerying` cobre a cascata de abertura (#1822): as requisições em série
  // rodam antes da consulta final ter seu próprio isFetching, então sem isto o
  // gráfico mostraria a dica vazia sem spinner até a última requisição.
  if (isFetching || autoQuerying) {
    return (
      <div className="tracking-forecast-detailed-view-chart mt-2">
        <CentralizedSpinner />
      </div>
    );
  }

  if (queryError) {
    return (
      <div className="tracking-forecast-detailed-view-chart mt-3">
        <QueryErrorState title={queryError.data} message={queryError.description} />
      </div>
    );
  }

  return (
    <div className="tracking-forecast-detailed-view-chart mt-3">
      {data && matrix && <HeatmapTable key={key} matrix={matrix} />}
      {data && !matrix && <EChartsReact key={key} option={withScrollableLegend(data)} />}
      {!data && (
        <Snackbar className="text-center">Utilize o painel de controle para realizar uma consulta.</Snackbar>
      )}
    </div>
  );
}
